/// <amd-module name="DistributedTaskUI/SecurityComponent/UserPermissionsAuthorization/Actions/RoleAssignmentComponentSecurityActionsHub" />
import Roles_Contracts = require("SecurityRoles/Client/Contracts/SecurityRoles");
import { Action } from "VSS/Reflux/Action";
export class RoleAssignmentComponentSecurityActionsHub {
    constructor() {
        this.initialize();
    }
    public initialize(): void {
        this._addNewUser = new Action<Roles_Contracts.RoleAssignment[]>();
        this._initializeRoles = new Action<Roles_Contracts.SecurityRole[]>();
        this._initializeRoleAssignments = new Action<Roles_Contracts.RoleAssignment[]>();
        this._removeUser = new Action<string>();
        this._updateRoleAssignment = new Action<Roles_Contracts.RoleAssignment>();
        this._roleScope = new Action<string>();
        this._setErrorMessage = new Action<string>();
    }

    public get addNewUser(): Action<Roles_Contracts.RoleAssignment[]> {
        return this._addNewUser;
    }

    public get initializeRoles(): Action<Roles_Contracts.SecurityRole[]> {
        return this._initializeRoles;
    }

    public get initializeRoleAssignments(): Action<Roles_Contracts.RoleAssignment[]> {
        return this._initializeRoleAssignments;
    }

    public get removeUser(): Action<string> {
        return this._removeUser;
    }

    public get updateRoleAssignment(): Action<Roles_Contracts.RoleAssignment> {
        return this._updateRoleAssignment;
    }

    public get updateRoleScope(): Action<string> {
        return this._roleScope;
    }

    public get setErrorMessage(): Action<string> {
        return this._setErrorMessage;
    }

    private _addNewUser: Action<Roles_Contracts.RoleAssignment[]>;
    private _initializeRoles: Action<Roles_Contracts.SecurityRole[]>;
    private _initializeRoleAssignments: Action<Roles_Contracts.RoleAssignment[]>;
    private _removeUser: Action<string>;
    private _updateRoleAssignment: Action<Roles_Contracts.RoleAssignment>;
    private _roleScope: Action<string>;
    private _setErrorMessage: Action<string>;
}
